const state= {
    Items:{
        data:[],
        total:0
    }
};

const getters = {
    Items : (state) => state.Items,
};

const actions = {
    getItems({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/master-gl-account`,{
                params: params
            })
                .then(response => {
                    commit( 'setItems', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => {
                    reject( error )
                });
        });
    },
    createItem({commit},param){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/master-gl-account`,param)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => {
                    reject( error )
                });
        });
    },
    updateItem({commit},param){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/master-gl-account/${param.id}`,param)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => {
                    reject( error )
                });
        });
    },
    deleteItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/master-gl-account`, {
                data:{
                    ids:params
                }
            })
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setItems (state,data) {
        state.Items.data = data.items;
        state.Items.total = data.total;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}